import * as R from './routes';
import { LoadableComponent } from '@loadable/component';
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GuardRoute from 'Router/GuardRoute';
import isLogged from 'utils/isLogged';

type Props = {
  component: LoadableComponent<any>;
  path: string;
  fallback: JSX.Element; // kept for compatibility, but not used here
  [key: string]: any;
};

export default function PrivateRoute({
  component: Component,
  path,
  ...restProps
}: Props) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const userIsChangingThePass = pathname === R.PASSWORD_CHANGE;
  const isTokenDefined = isLogged();

  useEffect(() => {
    if (sessionStorage.getItem('fromTemporaryPassword') === 'true') {
      navigate(R.CHANGE_TEMPORARY_PASSWORD, { replace: true });
    }
  }, [navigate]);

  if (!isTokenDefined && !userIsChangingThePass) {
    return <Navigate to={R.LOGIN} replace />;
  }

  // If logged in or changing password
  return (
    <GuardRoute path={path}>
      <Component {...restProps} />
    </GuardRoute>
  );
}
